import type { BotConfig, BotVertical } from '../../types/leadBot.js';

// SMS Lead Bot — the VERTICAL SEAM. PURE.
//
// ⚠️ ONE RESOLVER, NOT A SCATTER OF `if (vertical === 'fitness')`. A vertical
// selects the rule pack (the stable RULES block), the deterministic detector (which
// hard stops run before the model) and the knowledge source (botKnowledgeBases for
// automotive, businessProfiles for fitness). It is a union with an exhaustive
// switch whose default is a never-reached `never` — the lead-relay provider-seam
// pattern (LeadRoute.config) — so a THIRD vertical will not compile until every
// switch here handles it.
//
// ⚠️ ABSENT = AUTOMOTIVE. Every existing doc and every existing test keeps its
// behaviour with no migration, which is what the unchanged leadBot test suite
// proves.

export function resolveVertical(config: Pick<BotConfig, 'vertical'> | null | undefined): BotVertical {
  return config?.vertical ?? 'automotive';
}

export function assertNeverVertical(value: never): never {
  throw new Error(`Unhandled bot vertical: ${String(value)}`);
}

export interface VerticalPack {
  vertical: BotVertical;
  /** Which store the knowledge comes from. */
  knowledgeSource: 'botKnowledgeBases' | 'businessProfiles';
  /** Which deterministic detector runs before the model. */
  detector: 'handoff' | 'fitnessHardStops';
  /** Which stable RULES block heads the prompt. */
  rulePack: 'automotive' | 'fitness';
}

export function resolveVerticalPack(vertical: BotVertical): VerticalPack {
  switch (vertical) {
    case 'automotive':
      return {
        vertical,
        knowledgeSource: 'botKnowledgeBases',
        detector: 'handoff',
        rulePack: 'automotive',
      };
    case 'fitness':
      return {
        vertical,
        knowledgeSource: 'businessProfiles',
        detector: 'fitnessHardStops',
        rulePack: 'fitness',
      };
    default:
      return assertNeverVertical(vertical);
  }
}

export const VERTICAL_LABELS: Record<BotVertical, string> = {
  automotive: 'Automotive / vehicle dealer',
  fitness: 'Fitness club',
};
